
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAttachment as ObiAttachmentElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-attachment.js';
 
 
 

 
 export const ObiAttachment = createComponent({
   react: React,
   tagName: 'obi-attachment',
   elementClass: ObiAttachmentElement,
   events: {
     
   }
  });
 
 